import { ProgramRegion } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getStaffProgramWinnerRegions: (
  fetchContext: FetchContext,
  programId: number,
  accessToken?: string,
) => Promise<ProgramRegion[]> = (fetchContext, programId, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/staff/programs/${programId}/winner-regions`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  },
).then((response) => responseErrorHandler<ProgramRegion[]>(fetchContext.errorStore, response, 'get staff program winner regions'));
